
if( document.querySelector('.content-slider') ) {
    jQuery('.content-slider').closest('.row').each( function() {
        const $content = jQuery(this).find('.content-slider');
        const $images = jQuery(this).find('.image-slider');
        $content.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            fade: false,
            dots: true,
            rows: 0,
            asNavFor: $images,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    // asNavFor: false
                }
            }],
            arrows: true,
            prevArrow: jQuery('.content-slider-arrows .prev'),
            nextArrow: jQuery('.content-slider-arrows .next'),
        });
        $images.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: $content,
            infinite: false,
            dots: false,
            fade: true,
            // arrows: false,
            arrows: true,
            prevArrow: jQuery('.content-slider-arrows .prev'),
            nextArrow: jQuery('.content-slider-arrows .next'),
            rows: 0,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    // asNavFor: false
                }
            }]
        });
    })
}